export default __webpack_public_path__ + "static/media/video.86d43533.mp4";